import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const ecgQuestions = [
  {
    field: 'ecg_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'ecg_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    extras: { sendToBeluga: false },
    answer: {},
    type: 'info',
    blockQuestionFlow: true,
    isLast: true
  },
  {
    field: 'ecg_sexAssignedAtBirth',
    label: 'What was your sex assigned at birth?',
    extras: { sendToBeluga: false },
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Male',
          key: 'male'
        },
        {
          value: 'Female',
          key: 'female'
        }
      ]
    }
  },
  {
    field: 'ecg_pregnancyStatus',
    label:
      'Are you currently pregnant, breastfeeding or planning to become pregnant?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'Yes',
          key: 'yes'
        },
        {
          value: 'No',
          key: 'no'
        }
      ]
    }
  },
  {
    field: 'ecg_medicalConditions',
    label:
      'Do you have any of the following medical conditions? (check all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'Diagnosed cardiac (heart) condition',
          key: 'cardiac_condition'
        },
        {
          value: 'Irregular Heart beats / Arrhythmias',
          key: 'arrhythmias'
        },
        {
          value: 'High / Low Blood Pressure',
          key: 'blood_pressure'
        },
        {
          value: 'Diabetes / Difficulty controlling blood sugar',
          key: 'diabetes'
        },
        {
          value: 'High Cholesterol',
          key: 'high_cholesterol'
        },
        {
          value: 'Respiratory disease / Lung disease',
          key: 'respiratory_disease'
        },
        {
          value: 'Stroke',
          key: 'stroke'
        },
        {
          value: 'Sleep Apnea',
          key: 'sleep_apnea'
        },
        {
          value: 'Peripheral Artery Disease / Peripheral Vascular Disease',
          key: 'peripheral_artery_disease'
        },
        {
          value: 'None of these apply to me',
          key: 'none',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    field: 'ecg_conditionDetails',
    label:
      'Please provide a bit more information about this condition such as the name of this condition and how it has been treated',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'ecg_conditionDetails'
    }
  },
  {
    field: 'ecg_cardiacSymptoms',
    label:
      'Please list any cardiac symptoms that you have experienced recently (Select all that apply):',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'Chest pain or discomfort',
          key: 'chest_pain'
        },
        {
          value: 'Shortness of breath',
          key: 'shortness_breath'
        },
        {
          value:
            'Fatigue or reduced ability to exercise or perform physical activities',
          key: 'fatigue'
        },
        {
          value: 'Palpitations, Rapid or irregular heartbeat',
          key: 'palpitations'
        },
        {
          value: 'Dizziness, fainting or lightheadedness',
          key: 'dizziness'
        },
        {
          value: 'Swelling in legs, ankles, or feet',
          key: 'swelling'
        },
        {
          value: 'Nausea or vomiting',
          key: 'nausea'
        },
        {
          value: 'Pain in neck, jaw, back, or arms',
          key: 'pain_extremities'
        },
        {
          value: 'Indigestion or heartburn',
          key: 'indigestion'
        },
        {
          value: 'Anxiety',
          key: 'anxiety'
        },
        {
          value: "I'm NOT experiencing any of these symptoms",
          key: 'none',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    field: 'ecg_urgentEvaluationConsent',
    label: 'ECG Monitoring Understanding and Consent',
    type: 'select',
    educationalSlide:
      'An ECG (electrocardiogram) is a great tool for monitoring your heart rate and rhythm. It can help identify patterns in how your heart is beating. However, an ECG is not designed to diagnose heart disease or to evaluate urgent symptoms such as chest pain, shortness of breath, dizziness, swelling, and/or fainting among other cardiac symptoms.\n\nIf you are currently experiencing any cardiac symptoms, we can still offer an ECG to monitor your heart rate and rhythm, but you should be seen in person by a medical provider immediately to fully assess your condition and rule out any serious concerns.',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I understand that this is not used to diagnose my symptoms and I would NOT like to continue',
          class: 'option-decline',
          key: 'decline'
        },
        {
          value:
            'I understand that I need an urgent evaluation by an in-person provider, I would still like to order this device to help monitor my heart rate and rhythm.',
          class: 'option-consent',
          key: 'consent_with_understanding'
        }
      ]
    }
  },
  {
    field: 'ecg_contraindications',
    label: 'Do any of the following apply to you? (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value:
            'I have known skin allergies to the following: Silicone Rubber, Nylon',
          key: 'skin_allergies'
        },
        {
          value:
            'I have injuries or broken skin near where the chest strap may be placed',
          key: 'skin_injuries'
        },
        {
          value: 'I have a pacemaker, ICD or other implanted device',
          key: 'implanted_device'
        },
        {
          value: 'I am currently undergoing a medical emergency',
          key: 'medical_emergency'
        },
        {
          value: 'None of these apply',
          key: 'none',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    field: 'ecg_additionalQuestions',
    label: 'What other information or questions do you have for the doctor?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'ecg_additionalQuestions'
    }
  },

  {
    field: 'ecg_truthfulnessConsent',
    label: 'Consent (Truthfulness):',
    type: 'select',
    educationalSlide:
      'Please attest to the following confirming that all information you have provided to us is true and complete.\n\nI verify that I am the patient and that I have answered the questions asked in this intake form. I confirm that I have reviewed and understood all the questions asked of me. I attest that the answers and information I have provided in this questionnaire is true and complete to the best of my knowledge. I understand that it is critical to my health to share complete health information with my doctor. I will not hold the doctor or affiliated medical practice responsible for any oversights or omissions, whether intentional or not, in the information that I provided.',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read the above information and I do not wish to continue',
          class: 'option-decline',
          key: 'decline'
        },
        {
          value:
            'I have read the above information and I do consent and wish to move forward',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    field: 'ecg_deviceConsent',
    label: 'Consent (ECG (Electrocardiogram) Monitoring Device):',
    type: 'select',
    educationalSlide:
      'Purpose:\nYou are requesting an ECG (electrocardiogram) monitoring device to track your heart rate and rhythm over time. This device is intended for general monitoring purposes and is not used to diagnose heart disease or treat symptoms such as chest pain, shortness of breath, dizziness, or other urgent medical concerns.\n\nPotential Benefits:\n• Allows you to monitor and track your heart rate and rhythm from home\n• May help detect abnormal patterns over time\n• Can assist your healthcare provider in evaluating trends related to cardiac function\n\nPotential Risks and Limitations:\n• The device does not replace in-person medical evaluation\n• It is not designed to diagnose or treat any medical condition\n• Delaying appropriate in-person care in the presence of symptoms could result in serious harm\n• The device may not work correctly in patients with certain medical devices (e.g., pacemakers) or skin conditions\n\nPatient Acknowledgment and Consent:\n• I understand that this ECG device is for heart rate and rhythm monitoring only.\n• I understand that it is not intended to diagnose or manage medical emergencies.\n• I agree to seek in-person medical care immediately if I develop any symptoms such as chest pain, shortness of breath, fainting, or irregular heartbeat.\n• I consent to receive and use this device for monitoring purposes as explained above.',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read the above information and I do not wish to continue',
          class: 'option-decline',
          key: 'decline'
        },
        {
          value:
            'I have read and understand the above information and I do consent and wish to move forward with this treatment plan',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  }
] as const;

const _type = ecgQuestions;
export type ECGQuestionFieldAnswers = Partial<QuestionAnswerMap<typeof _type>>;

export default ecgQuestions;
